
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Projects from "../pages/projects/page";
import ContatoPage from '../pages/contato/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/quem-somos",
    element: <About />,
  },
  {
    path: "/servicos",
    element: <Services />,
  },
  {
    path: "/projetos",
    element: <Projects />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
